import {
  deleteUserFromDB,
  getAllUsersFromDB,
} from "../../service/dashboard/dashBoardServicel";
import { User } from "../../types/types";

const getAllusers = async () => {
  const users: User[] = await getAllUsersFromDB();
  return users;
};

const deleteUser = async (id: number) => {
  try {
    await deleteUserFromDB(id);
    return { success: true };
  } catch (error) {
    console.error("Error deleting user:", error);
    return { success: false, error };
  }
};

export { getAllusers, deleteUser };
